// B 站发货
const Home = () => import('../pages/bilibiliShipments/index.vue');
const Info = () => import('../pages/bilibiliShipments/orderInfo.vue');
const Result = () => import('../pages/bilibiliShipments/submitResult.vue');
const CheckPhone = () => import('../pages/bilibiliShipments/checkPhone.vue');
const OrderList = () => import('../pages/bilibiliShipments/orderList.vue');
const OrderDetail = () => import('../pages/bilibiliShipments/orderDetail.vue');
const EditAddress = () => import('../pages/bilibiliShipments/editAdress.vue');

export default [
  {
    path: '/bilibili-shipments/order-list',
    component: OrderList,
    meta: {
      title: '我的订单',
    },
  },
  {
    path: '/bilibili-shipments/order-detail/:orderNo',
    component: OrderDetail,
    meta: {
      title: '订单详情',
    },
  },
  {
    path: '/bilibili-shipments/order-info',
    component: Info,
    meta: {
      title: 'B站发货',
    },
  },
  {
    path: '/bilibili-shipments/result',
    component: Result,
    name: 'bilibiliOrderResult',
    meta: {
      title: 'B站发货',
    },
  },
  {
    path: '/bilibili-shipments/check-phone',
    component: CheckPhone,
    meta: {
      title: 'B站发货',
    },
  },
  {
    path: '/bilibili-shipments/edit-address',
    component: EditAddress,
    name: 'editAddress',
    meta: {
      title: '修改地址',
    },
  },
  {
    path: '/bilibili-shipments/:type',
    component: Home,
    meta: {
      title: 'B站发货',
    },
  },
];
